import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useLocale } from '../i18n'

function StatusPanel() {
  const [logs, setLogs] = useState([])
  const location = useLocation()
  const { t } = useLocale()
  
  
  useEffect(() => {
    // 監聽路由變化，記錄到 logs
    const timestamp = new Date().toLocaleTimeString()
    setLogs(prev => [...prev.slice(-4), t('status.routeChanged', { time: timestamp, path: location.pathname })])
  }, [location, t])
  
  return (
    <div className="status-panel">
      <div className="status-title">📊 {t('status.title')}</div>
      <div className="config-display">
        <strong>{t('status.current')}</strong>
        
        <strong style={{display: 'block', marginTop: '1rem'}}>{t('status.recent')}</strong>
        {logs.map((log, index) => (
          <div key={index}>{log}</div>
        ))}
      </div>
    </div>
  )
}

export default StatusPanel
